export const RENTAL = {
  isHidden: true,
  nickname: 'PRODUCTS.RENTAL.nickname',
  icon:'rental'
};
